import React from 'react';
import './IslamicRibbon.css';

const IslamicRibbon = () => {
    const message = "Allah alone is the Eternal Divine, and Muhammad صَلَّى ٱللّٰهُ عَلَيْهِ وَآلِهِ وَسَلَّمَ is the Seal and completion of His Prophethood.";

    return (
        <div className="islamic-ribbon w-full h-[25px] bg-gradient-to-r from-green-600 to-green-700 overflow-hidden relative">
            <div className="absolute inset-0 flex items-center">
                <div className="islamic-ribbon-marquee whitespace-nowrap">
                    <span className="text-white text-[13px] sm:text-[14px] font-medium tracking-wide inline-block">
                        {message}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default IslamicRibbon;

